import { Guid } from '../../../model/guid';
import { ScormClientCompressionWrapper } from './scorm/scormClientCompressionWrapper';
import { IPersistenceTrackingClient, TrackingClient, TrackingDataVersion } from './trackingClient';
import { TrackingClientTrackingIdWrapper } from './TrackingClientTrackingIdWrapper';
import { TrackingIdentifier } from '@ael/core-api';
import { List, Set } from 'immutable';

export const getTrackingClient = (
  getParent: (childId: Guid) => Guid | null,
  getChildrenForScorm: (
    parentId: Guid,
    finishedItemIds?: Set<string>,
    trackingDataVersion?: TrackingDataVersion
  ) => List<Guid> | null,
  convertItemIdToTrackingId: (itemId: Guid) => TrackingIdentifier,
  initializedPersistenceTrackingClient: IPersistenceTrackingClient
): TrackingClient => {
  if (initializedPersistenceTrackingClient.name === 'SCORM') {
    return new ScormClientCompressionWrapper(
      getParent,
      getChildrenForScorm,
      new TrackingClientTrackingIdWrapper(convertItemIdToTrackingId, initializedPersistenceTrackingClient)
    );
  }

  const clientToReturn = new TrackingClientTrackingIdWrapper(
    convertItemIdToTrackingId,
    initializedPersistenceTrackingClient
  );

  return clientToReturn;
};
